import { IDeleteInformacaoFaturamentoUseCase } from "../../../presentation/useCases/delete/delete_informacao_faturamento_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteinformacaoFaturamentoUseCase
 */

export class DeleteInformacaoFaturamentoUseCase implements IDeleteInformacaoFaturamentoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async deleteInformacaoFaturamento(idInfFaturamento: number): Promise<void> {
    await this.repository.deleteInformacaoFaturamento(idInfFaturamento);

  }
}
